import { reverseArray as V, flatten2DArray as j } from "./7PRQYBBV.js";
import { createCollectionStore as q } from "./EO4GVUA4.js";
import { createStore as H, setup as J, sync as K } from "./BCALMBPZ.js";
import { defaultValue as a } from "./PBFD2E7P.js";
import { __spreadProps as R, __spreadValues as g } from "./3YLGPPWQ.js";
var Q = { id: null };
function c(n, r) {
  return n.find((t) => r ? !t.disabled && t.id !== r : !t.disabled);
}
function X(n, r) {
  return n.filter((t) => r ? !t.disabled && t.id !== r : !t.disabled);
}
function C(n, r) {
  return n.filter((t) => t.rowId === r);
}
function Z(n, r, t = !1) {
  const l = n.findIndex((o) => o.id === r);
  return [
    ...n.slice(l + 1),
    ...t ? [Q] : [],
    ...n.slice(0, l)
  ];
}
function P(n) {
  const r = [];
  for (const t of n) {
    const l = r.find((o) => {
      var u;
      return ((u = o[0]) == null ? void 0 : u.rowId) === t.rowId;
    });
    l ? l.push(t) : r.push([t]);
  }
  return r;
}
function $(n) {
  let r = 0;
  for (const { length: t } of n)
    t > r && (r = t);
  return r;
}
function ee(n) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    rowId: n
  };
}
function te(n, r, t) {
  const l = $(n);
  for (const o of n)
    for (let u = 0; u < l; u += 1) {
      const i = o[u];
      if (!i || t && i.disabled) {
        const e = u === 0 && t ? c(o) : o[u - 1];
        o[u] = e && r !== e.id && t ? e : ee(e == null ? void 0 : e.rowId);
      }
    }
  return n;
}
function ne(n) {
  const r = P(n), t = $(r), l = [];
  for (let o = 0; o < t; o += 1)
    for (const u of r) {
      const i = u[o];
      i && l.push(R(g({}, i), {
        // If there's no rowId, it means that it's not a grid composite, but
        // a single row instead. So, instead of verticalizing it, that is,
        // assigning a different rowId based on the column index, we keep it
        // undefined so they will be part of the same row. This is useful
        // when using up/down on one-dimensional composites.
        rowId: i.rowId ? `${o}` : void 0
      }));
    }
  return l;
}
function de(n = {}) {
  var r;
  const t = (r = n.store) == null ? void 0 : r.getState(), l = q(n), o = a(
    n.activeId,
    t == null ? void 0 : t.activeId,
    n.defaultActiveId
  ), u = R(g({}, l.getState()), {
    id: a(
      n.id,
      t == null ? void 0 : t.id,
      `id-${Math.random().toString(36).slice(2, 8)}`
    ),
    activeId: o,
    baseElement: a(t == null ? void 0 : t.baseElement, null),
    includesBaseElement: a(
      n.includesBaseElement,
      t == null ? void 0 : t.includesBaseElement,
      o === null
    ),
    moves: a(t == null ? void 0 : t.moves, 0),
    orientation: a(
      n.orientation,
      t == null ? void 0 : t.orientation,
      "both"
    ),
    rtl: a(n.rtl, t == null ? void 0 : t.rtl, !1),
    virtualFocus: a(
      n.virtualFocus,
      t == null ? void 0 : t.virtualFocus,
      !1
    ),
    focusLoop: a(n.focusLoop, t == null ? void 0 : t.focusLoop, !1),
    focusWrap: a(n.focusWrap, t == null ? void 0 : t.focusWrap, !1),
    focusShift: a(n.focusShift, t == null ? void 0 : t.focusShift, !1)
  }), i = H(u, l, n.store);
  J(
    i,
    () => K(i, ["renderedItems", "activeId"], (e) => {
      i.setState("activeId", (I) => {
        var x;
        return I !== void 0 ? I : (x = c(e.renderedItems)) == null ? void 0 : x.id;
      });
    })
  );
  const w = (e = "next", I = {}) => {
    var x, p;
    const m = i.getState(), {
      skip: _ = 0,
      activeId: f = m.activeId,
      focusShift: G = m.focusShift,
      focusLoop: E = m.focusLoop,
      focusWrap: L = m.focusWrap,
      includesBaseElement: F = m.includesBaseElement,
      renderedItems: W = m.renderedItems,
      rtl: k = m.rtl
    } = I, v = e === "up" || e === "down", z = e === "next" || e === "down", O = z ? k && !v : !k || v, U = G && !_;
    let s = v ? j(
      te(P(W), f, U)
    ) : W;
    if (s = O ? V(s) : s, s = v ? ne(s) : s, f == null)
      return (x = c(s)) == null ? void 0 : x.id;
    const h = s.find((d) => d.id === f);
    if (!h)
      return (p = c(s)) == null ? void 0 : p.id;
    const M = s.some((d) => d.rowId), Y = s.indexOf(h), A = s.slice(Y + 1), y = C(A, h.rowId);
    if (_) {
      const d = X(y, f), b = d.slice(_)[0] || // If we can't find an item, just return the last one.
      d[d.length - 1];
      return b == null ? void 0 : b.id;
    }
    const N = E && (v ? E !== "horizontal" : E !== "vertical"), D = M && L && (v ? L !== "horizontal" : L !== "vertical"), S = z ? (!M || v) && N && F : v ? F : !1;
    if (N) {
      const d = D && !S ? s : C(s, h.rowId), b = Z(d, f, S), T = c(b, f);
      return T == null ? void 0 : T.id;
    }
    if (D) {
      const d = c(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        S ? y : A,
        f
      );
      return S ? (d == null ? void 0 : d.id) || null : d == null ? void 0 : d.id;
    }
    const B = c(y, f);
    return !B && S ? null : B == null ? void 0 : B.id;
  };
  return R(g(g({}, l), i), {
    setBaseElement: (e) => i.setState("baseElement", e),
    setActiveId: (e) => i.setState("activeId", e),
    move: (e) => {
      e !== void 0 && (i.setState("activeId", e), i.setState("moves", (I) => I + 1));
    },
    first: () => {
      var e;
      return (e = c(i.getState().renderedItems)) == null ? void 0 : e.id;
    },
    last: () => {
      var e;
      return (e = c(V(i.getState().renderedItems))) == null ? void 0 : e.id;
    },
    next: (e) => (e !== void 0 && typeof e == "number" && (e = { skip: e }), w("next", e)),
    previous: (e) => (e !== void 0 && typeof e == "number" && (e = { skip: e }), w("previous", e)),
    down: (e) => (e !== void 0 && typeof e == "number" && (e = { skip: e }), w("down", e)),
    up: (e) => (e !== void 0 && typeof e == "number" && (e = { skip: e }), w("up", e))
  });
}
export {
  de as createCompositeStore
};
//# sourceMappingURL=2CHYBBFH.js.map
